import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Clock } from 'lucide-react';
import { DialplanNodeData } from '@/types/dialplan-nodes';

export const TimeConditionNode: React.FC<NodeProps<DialplanNodeData>> = ({ data, selected }) => {
  return (
    <div
      className={`
        px-4 py-3 rounded-lg border-2 bg-gradient-to-br from-orange-50 to-orange-100
        ${selected ? 'border-orange-500 shadow-lg' : 'border-orange-300 shadow'}
        min-w-[180px]
      `}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="!bg-orange-500 !w-3 !h-3"
      />

      <div className="flex items-center gap-2 mb-2">
        <Clock className="h-5 w-5 text-orange-600" />
        <div className="flex-1">
          <div className="font-semibold text-orange-900">{data.label}</div>
          {data.description && (
            <div className="text-xs text-orange-700">{data.description}</div>
          )}
        </div>
        {!data.enabled && (
          <div className="px-2 py-0.5 bg-gray-200 text-gray-600 text-xs rounded">
            Disabled
          </div>
        )}
      </div>

      {data.dialplanConfig?.timeRanges && data.dialplanConfig.timeRanges.length > 0 && (
        <div className="text-xs text-orange-700 mt-1">
          {data.dialplanConfig.timeRanges.length} time range(s)
        </div>
      )}

      {data.priority !== undefined && (
        <div className="text-xs text-orange-700 mt-1">
          Priority: {data.priority}
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        className="!bg-orange-500 !w-3 !h-3"
      />
    </div>
  );
};

